import React from 'react'
import { KonfhubButton } from './Buttons'
import sparkles from "../../assets/img/Pricing-plan/sparkles.svg"
import lockPurple from "../../assets/img/Pricing-plan/lock-icon-purple.svg"
import { useHistory } from "react-router-dom"
import { dashboardColors, theme } from '../../themes/Theme'
import customToast from '../../components/common/basic/Toast'

export default function Banner({ children }) {

    const history = useHistory();

    return (
        <div className='px-sm-3 px-lg-5 px-0 pt-4 pb-4 d-flex justify-content-center upgrade-banner-container'>  
            <div className="upgrade-banner d-flex flex-wrap px-3 py-3 justify-content-center my-auto align-items-center">
                <div className='upgrade-banner-lock d-flex justify-content-center align-items-center mr-2'>
                    <img src={lockPurple} alt='lock icon' style={{width: "14px", height: "14px"}} />
                </div>
                <h4 className="upgrade-banner-div mr-3 text-center">
                    {children}
                </h4>

                <KonfhubButton 
                    onClick={() => {
                        const email = "reachus@konfhub.com"
                        window.location = "mailto:reachus@konfhub.com"
                        navigator.clipboard.writeText(email).then(() => {
                            customToast.success(`We've copied reachus@konfhub.com to your clipboard. If your email client didn’t open, you can paste the address into any email service`);
                        });
                        // history.push(`${history.location.pathname}?plan=Lite`)
                    }}
                >   
                    Contact to Upgrade
                    <img src={sparkles} className='ml-1' alt='sparkles'/>
                </KonfhubButton>

                {children?.includes('White Label') && <div className='d-flex mt-2 text-center  align-item-center richtext-gap-1'>
                    <p className="note-text"> <span className='white-label-note mr-1'>Note: </span> Events linked to an event profile must upgrade to the gold plan to access linked event profile's white label settings.</p>

                </div>}
            </div>

            <style>{`
                .upgrade-banner {
                    min-height: 25px;
                    background: #FFF;
                    border: 1px solid  ${dashboardColors[theme].primary};
                    box-shadow: 0px 0px 15.3px 0px #57214824;
                    // width: fit-content;
                    width: 100%;
                    // font-size: 16px;
                    color: ${dashboardColors[theme].primaryTextColor};
                }	
                .upgrade-banner-container {
                    position: sticky;
                    top: 0px;
                    background: transparent;
                    z-index: 98;
                }
                .upgrade-banner-div{
                    font-size: 16px;
                    margin-top: 10px;        
                }
                .upgrade-banner-lock {
                    background: #ecf2ff;
                    border-radius: 100%;
                    width: 30px;
                    height: 30px;
                }
                .white-label-note {
                    font-size:16px;
                    font-weight:600;
                    color:${dashboardColors[theme].primaryTextColor} ;
                }
                .white-label-note .note-text{
                    font-size:14px;
                    font-weight:400;
                    color:${dashboardColors[theme].primaryTextColor} ;
                }
                @media (max-width: 600px) {
                    .upgrade-banner-div{
                        font-size: 12.5px !important;
                    }
                }
			
            `}</style>
        </div>
    )
}

